/*
 * @Author: 秦少卫
 * @Date: 2024-09-07 09:59:03
 * @LastEditors: 秦少卫
 * @LastEditTime: 2024-09-07 10:43:10
 * @Description: file content
 */

import { get } from 'lodash-es';
import enUS from './lang/en-US.json';
import zhCN from './lang/zh-CN.json';
import jaJP from './lang/ja-JP.json';
import koKR from './lang/ko-KR.json';
import zhTW from './lang/zh-TW.json';

const langMap = {
  'en-US': enUS,
  'zh-CN': zhCN,
  'ja-JP': jaJP,
  'ko-KR': koKR,
  'zh-TW': zhTW,
} as { [key: string]: any };

let lang = '' as string;
export const t = (key: string) => {
  const langKey = lang || 'zh-CN';
  return get(langMap[langKey], key) || key;
};

export const setLang = (key: string) => {
  lang = key;
};

export default {
  'en-US': enUS,
  'zh-CN': zhCN,
  'ja-JP': jaJP,
  'ko-KR': koKR,
  'zh-TW': zhTW,
};
